import { styled } from "@mui/material/styles";

import {
  accessibleInteractiveColors,
  visualTokens,
} from "@/theme/accessibility";

const actionButtonBase = {
  minWidth: "0",
  minHeight: "36px",
  height: "36px",
  padding: "6px 12px",
  fontSize: "12px",
  fontWeight: "600",
  lineHeight: "18px",
  borderRadius: "6px",
  boxSizing: "border-box",
} as const;

export const CostumeButtonStyled = styled("div")(() => ({
  "& .btn": {
    gap: "6px",
  },
  "& .btn .MuiButton-startIcon, & .btn .MuiButton-endIcon": {
    display: "inline-flex",
    alignItems: "center",
    margin: "0 !important",
  },
  "& .btn .MuiButton-startIcon svg, & .btn .MuiButton-endIcon svg": {
    width: "16px",
    height: "16px",
    margin: "0 !important",
    flexShrink: 0,
  },
  "& .addMember": {
    background: visualTokens.surfaceMint,
    width: "calc(100% - 20px)",
    height: "53px",
    color: visualTokens.ink,
    fontWeight: "500",
    fontSize: "16px",
    alignItems: "center",
    margin: "10px",
    display: "flex",
    boxSizing: "border-box",
    minWidth: "0 !important",
    // position: "relative",
    justifyContent: "start",
    padding: "9px 8px",
    fontFamily: "Poppins",
  },
  "& .addMember span.service-memeberlist-add-new": {
    flex: "1 1 auto",
    minWidth: 0,
    paddingLeft: "18px",
    width: "auto",
    whiteSpace: " nowrap",
    textOverflow: " ellipsis",
    overflow: "hidden",
    display: "block",
    textAlign: "left",
  },
  // "& .addMember svg": {
  //   position: "absolute",
  //   top: "7px",
  // },
  "& .addStaff": {
    margin: "10px",
    fontFamily: "Poppins",
  },
  "& .svgIcon": {
    position: "relative",
    top: "10px",
    right: "10px",
  },
  "& .costume": {
    background: accessibleInteractiveColors.actionGreen,
    ...actionButtonBase,
    alignItems: "center",
    color: visualTokens.textOnDark,
    margin: "0px 5px",
    width: "auto",
    fontFamily: "Poppins",
  },
  "& .delete": {
    background: `${visualTokens.danger} !important`,
    ...actionButtonBase,
    alignItems: "center",
    color: visualTokens.textOnDark,
    margin: "0px 5px",
    fontFamily: "Poppins",
    marginTop: "2%",
  },
  "& .invite": {
    background: visualTokens.actionBlue,
    ...actionButtonBase,
    alignItems: "center",
    color: visualTokens.textOnDark,
    margin: "0px 10px",
    fontFamily: "Poppins",
  },

  "& .invites": {
    background: visualTokens.danger,
    ...actionButtonBase,
    alignItems: "center",
    color: visualTokens.textOnDark,
    margin: "0px 10px",
    fontFamily: "Poppins",
  },

  "& .discard": {
    ...actionButtonBase,
    background: "#FFFFFF",
    alignItems: "center",
    color: visualTokens.actionBlue,
    margin: "0px 10px",
    border: `1px solid ${visualTokens.actionBlue}`,
    fontFamily: "Poppins",
  },
  "& .export": {
    background: visualTokens.ink,
    ...actionButtonBase,
    alignItems: "center",
    color: visualTokens.textOnDark,
    margin: "0px 10px",
    fontFamily: "Poppins",
    display: "flex",
    whiteSpace: "nowrap",
  },
  "& .cancel": {
    background: visualTokens.surfaceDisabled,
    ...actionButtonBase,
    alignItems: "center",
    color: "#294C70",
    margin: "0px 10px",
    border: "1px solid #8FB6D9",
    fontFamily: "Poppins",
  },
  "& .zone": {
    background: "#fff",
    margin: "0px 6px",
    fontSize: "12px",
    fontWeight: "300px !important",
    color: visualTokens.actionBlue,
    border: `1px solid ${visualTokens.actionBlue}`,
    height: "30px",
    padding: "1px 5px 1px 6px!important",
    // width: "98px !important",
    fontFamily: "Poppins",
  },
  "& .Zone": {
    background: visualTokens.textOnDark,
    margin: "0px 10px",
    fontSize: "12px",
    fontWeight: "300px !important",
    color: visualTokens.actionBlue,
    border: `1px solid ${visualTokens.actionBlue}`,
    height: "30px",
    padding: "0!important",
    // width: "98px",
    fontFamily: "Poppins",
  },
  "& .status": {
    background: `${visualTokens.actionBlue} !important`,
    height: "30px",
    fontSize: "12px",
    fontWeight: "300px",
    color: visualTokens.textOnDark,
    border: `1px solid ${visualTokens.textOnDark}`,
    padding: "3px 6px",
    margin: "0px 10px 0px",
    width: "91px",
    fontFamily: "Poppins",
  },
  "& .costumes": {
    ...actionButtonBase,
    alignItems: "center",
    background: accessibleInteractiveColors.actionGreen,
    color: visualTokens.textOnDark,
    fontFamily: "Poppins",
    gap: "6px",
    width: "auto",
  },
  "& .Cancel": {
    ...actionButtonBase,
    background: visualTokens.textOnDark,
    border: `1px solid ${visualTokens.ink}`,
    margin: "0px 10px",
    color: visualTokens.ink,
    fontFamily: "Poppins",
  },
  "& .Delete": {
    ...actionButtonBase,
    width: "auto !important",
    paddingInline: "12px !important",
    background: visualTokens.danger,
    border: `1px solid ${visualTokens.danger}`,
    color: visualTokens.textOnDark,
    fontFamily: "Poppins",
  },
  "& .Delete:hover": {
    background: visualTokens.dangerHover,
  },
  "& .Delete:disabled": {
    background: visualTokens.surfaceDisabled,
    cursor: "not-allowed",
    color: "#294C70",
    border: "#8FB6D9",
  },
  "& .addMember:hover": {
    background: visualTokens.surfaceMint,
  },
  "& .costume:hover": {
    background: `${accessibleInteractiveColors.actionGreen}!important`,
  },
  "& .costumes:hover": {
    background: `${accessibleInteractiveColors.actionGreen}!important`,
  },

  "& .cancel:hover": {
    background: `${visualTokens.surfaceDisabled}!important`,
  },
  "& .export:hover ": {
    background: `${visualTokens.ink}!important`,
  },
  "& .invite:hover ": {
    background: `${visualTokens.actionBlue}!important`,
  },
  "& .delete:hover ": {
    background: `${visualTokens.danger}!important`,
  },
  "& .weekData": {
    border: "1px solid #989696",
    Width: "70px",
    Height: "35px",
    borderRadius: "10px",
    Padding: "3px, 10px, 3px, 10px",
    Gap: "10px",
    color: "#989696",
  },
  "& .zone svg": {
    margin: "2px 0px 0px 5px",
  },
  "& .Zone svg": {
    margin: "2px 0px 0px 24px",
  },
  "& .delete-assessments": {
    ...actionButtonBase,
    color: visualTokens.danger,
    border: `1px solid ${visualTokens.danger}`,
    width: "200px",
    marginRight: "10px",
  },

  "& .draft": {
    ...actionButtonBase,
    // background: "##1F4970",
    color: visualTokens.ink,
    border: `1px solid ${visualTokens.ink}`,
    alignItems: "center",
    margin: "0px 2px",
    fontFamily: "Poppins",
    width: "130px",
  },

  "& .review": {
    ...actionButtonBase,
    background: visualTokens.actionGreen,
    color: visualTokens.textOnDark,
    border: `1px solid ${visualTokens.actionGreen}`,
  },
}));
